var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 111C328.1 101.6 312.9 101.6 303.6 111L143.5 271C134.1 280.4 134.1 295.6 143.5 304.9C152.9 314.2 168.1 314.3 177.4 304.9L320.4 161.9L463.4 304.9C472.8 314.3 488 314.3 497.3 304.9C506.6 295.5 506.7 280.3 497.3 271L337.5 111zM497.5 463L337.5 303C328.1 293.6 312.9 293.6 303.6 303L143.5 463C134.1 472.4 134.1 487.6 143.5 496.9C152.9 506.2 168.1 506.3 177.4 496.9L320.4 353.9L463.4 496.9C472.8 506.3 488 506.3 497.3 496.9C506.6 487.5 506.7 472.3 497.3 463z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon_up.547115ddfb44589b46ed46bf1bb5615b.svg";
export { ForwardRef as ReactComponent };